"use strict";
/**
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var _slicedToArray = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/slicedToArray");

var _toConsumableArray = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/toConsumableArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transcode = exports.getFieldNameOnBehavior = exports.isRequiredField = exports.isProto3OptionalField = exports.requestChangeCaseAndCleanup = exports.flattenObject = exports.match = exports.applyPattern = exports.encodeWithoutSlashes = exports.encodeWithSlashes = exports.buildQueryStringComponents = exports.deleteField = exports.deepCopy = exports.getField = void 0;

var util_1 = require("./util");

var httpOptionName = '(google.api.http)';
var fieldBehaviorOptionName = '(google.api.field_behavior)';
var proto3OptionalName = 'proto3_optional'; // List of methods as defined in google/api/http.proto (see HttpRule)

var supportedHttpMethods = ['get', 'post', 'put', 'patch', 'delete'];

function getField(request, field) {
  var parts = field.split('.');
  var value = request;
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = parts[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var part = _step.value;

      if (typeof value !== 'object') {
        return undefined;
      }

      value = value[part];
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  if (typeof value === 'object' && !Array.isArray(value) && value !== null) {
    return undefined;
  }

  return value;
}

exports.getField = getField;

function deepCopy(request) {
  if (typeof request !== 'object' || request === null) {
    return request;
  }

  var copy = Object.assign({}, request);

  for (var key in copy) {
    if (Array.isArray(copy[key])) {
      copy[key] = copy[key].map(deepCopy);
    } else if (typeof copy[key] === 'object' && copy[key] !== null) {
      copy[key] = deepCopy(copy[key]);
    }
  }

  return copy;
}

exports.deepCopy = deepCopy;

function deleteField(request, field) {
  var parts = field.split('.');

  while (parts.length > 1) {
    if (typeof request !== 'object') {
      return;
    }

    var _part = parts.shift();

    request = request[_part];
  }

  var part = parts.shift();

  if (typeof request !== 'object') {
    return;
  }

  delete request[part];
}

exports.deleteField = deleteField;

function buildQueryStringComponents(request) {
  var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var resultList = [];

  for (var key in request) {
    if (Array.isArray(request[key])) {
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = request[key][Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var value = _step2.value;
          resultList.push("".concat(prefix).concat(encodeWithoutSlashes(key), "=").concat(encodeWithoutSlashes(value.toString())));
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    } else if (typeof request[key] === 'object' && request[key] !== null) {
      resultList.push.apply(resultList, _toConsumableArray(buildQueryStringComponents(request[key], "".concat(key, "."))));
    } else {
      resultList.push("".concat(prefix).concat(encodeWithoutSlashes(key), "=").concat(encodeWithoutSlashes(request[key] === null ? 'null' : request[key].toString())));
    }
  }

  return resultList;
}

exports.buildQueryStringComponents = buildQueryStringComponents;

function encodeWithSlashes(str) {
  return str.split('').map(function (c) {
    return c.match(/[-_.~0-9a-zA-Z]/) ? c : encodeURIComponent(c);
  }).join('');
}

exports.encodeWithSlashes = encodeWithSlashes;

function encodeWithoutSlashes(str) {
  return str.split('').map(function (c) {
    return c.match(/[-_.~0-9a-zA-Z/]/) ? c : encodeURIComponent(c);
  }).join('');
}

exports.encodeWithoutSlashes = encodeWithoutSlashes;

function escapeRegExp(str) {
  return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

function applyPattern(pattern, fieldValue) {
  if (!pattern || pattern === '*') {
    return encodeWithSlashes(fieldValue);
  }

  if (!pattern.includes('*') && pattern !== fieldValue) {
    return undefined;
  } // since we're converting the pattern to a regex, make necessary precautions:


  var regex = new RegExp('^' + escapeRegExp(pattern).replace(/\\\*\\\*/g, '(.+)').replace(/\\\*/g, '([^/]+)') + '$');

  if (!fieldValue.match(regex)) {
    return undefined;
  }

  return encodeWithoutSlashes(fieldValue);
}

exports.applyPattern = applyPattern;

function match(request, pattern) {
  var url = pattern;
  var matchedFields = [];

  for (;;) {
    var _match = url.match(/^(.*)\{([^}=]+)(?:=([^}]*))?\}(.*)/);

    if (!_match) {
      break;
    }

    var _match2 = _slicedToArray(_match, 5),
        before = _match2[1],
        field = _match2[2],
        _pattern = _match2[3],
        after = _match2[4];

    matchedFields.push(field);
    var fieldValue = getField(request, field);

    if (typeof fieldValue === 'undefined') {
      return undefined;
    }

    var appliedPattern = applyPattern(_pattern, fieldValue === null ? 'null' : fieldValue.toString());

    if (typeof appliedPattern === 'undefined') {
      return undefined;
    }

    url = before + appliedPattern + after;
  }

  return {
    matchedFields: matchedFields,
    url: url
  };
}

exports.match = match;

function flattenObject(request) {
  var result = {};

  for (var key in request) {
    if (typeof request[key] === 'undefined') {
      continue;
    }

    if (Array.isArray(request[key])) {
      // According to the http.proto comments, a repeated field may only
      // contain primitive types, so no extra recursion here.
      result[key] = request[key];
      continue;
    }

    if (typeof request[key] === 'object' && request[key] !== null) {
      var nested = flattenObject(request[key]);

      for (var nestedKey in nested) {
        result["".concat(key, ".").concat(nestedKey)] = nested[nestedKey];
      }

      continue;
    }

    result[key] = request[key];
  }

  return result;
}

exports.flattenObject = flattenObject;

function requestChangeCaseAndCleanup(request, caseChangeFunc) {
  if (!request || typeof request !== 'object') {
    return request;
  }

  var convertedRequest = {};

  for (var field in request) {
    // cleaning up inherited properties
    if (!Object.prototype.hasOwnProperty.call(request, field)) {
      continue;
    }

    var convertedField = caseChangeFunc(field);
    var value = request[field];

    if (Array.isArray(value)) {
      convertedRequest[convertedField] = value.map(function (v) {
        return requestChangeCaseAndCleanup(v, caseChangeFunc);
      });
    } else {
      convertedRequest[convertedField] = requestChangeCaseAndCleanup(value, caseChangeFunc);
    }
  }

  return convertedRequest;
}

exports.requestChangeCaseAndCleanup = requestChangeCaseAndCleanup;

function isProto3OptionalField(field) {
  return field && field.options && field.options[proto3OptionalName];
}

exports.isProto3OptionalField = isProto3OptionalField;

function isRequiredField(field) {
  return field && field.options && field.options[fieldBehaviorOptionName] === 'REQUIRED';
}

exports.isRequiredField = isRequiredField;

function getFieldNameOnBehavior(fields) {
  var requiredFields = new Set();
  var optionalFields = new Set();

  for (var fieldName in fields) {
    var field = fields[fieldName];

    if (isRequiredField(field)) {
      requiredFields.add(fieldName);
    }

    if (isProto3OptionalField(field)) {
      optionalFields.add(fieldName);
    }
  }

  return {
    requiredFields: requiredFields,
    optionalFields: optionalFields
  };
}

exports.getFieldNameOnBehavior = getFieldNameOnBehavior;

function transcode(request, parsedOptions, requestFields) {
  var _getFieldNameOnBehavi = getFieldNameOnBehavior(requestFields),
      requiredFields = _getFieldNameOnBehavi.requiredFields,
      optionalFields = _getFieldNameOnBehavi.optionalFields; // all fields annotated as REQUIRED MUST be emitted in the body.


  var _iteratorNormalCompletion3 = true;
  var _didIteratorError3 = false;
  var _iteratorError3 = undefined;

  try {
    for (var _iterator3 = requiredFields[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
      var requiredField = _step3.value;

      if (!(requiredField in request) || request[requiredField] === 'undefined') {
        throw new Error("Required field ".concat(requiredField, " is not present in the request."));
      }
    } // request is supposed to have keys in camelCase.

  } catch (err) {
    _didIteratorError3 = true;
    _iteratorError3 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
        _iterator3.return();
      }
    } finally {
      if (_didIteratorError3) {
        throw _iteratorError3;
      }
    }
  }

  var snakeRequest = requestChangeCaseAndCleanup(request, util_1.camelToSnakeCase);
  var httpRules = [];
  var _iteratorNormalCompletion4 = true;
  var _didIteratorError4 = false;
  var _iteratorError4 = undefined;

  try {
    for (var _iterator4 = parsedOptions[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
      var option = _step4.value;

      if (!(httpOptionName in option)) {
        continue;
      }

      var httpRule = option[httpOptionName];
      httpRules.push(httpRule);

      if (httpRule === null || httpRule === void 0 ? void 0 : httpRule.additional_bindings) {
        var additionalBindings = Array.isArray(httpRule.additional_bindings) ? httpRule.additional_bindings : [httpRule.additional_bindings];
        httpRules.push.apply(httpRules, _toConsumableArray(additionalBindings));
      }
    }
  } catch (err) {
    _didIteratorError4 = true;
    _iteratorError4 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
        _iterator4.return();
      }
    } finally {
      if (_didIteratorError4) {
        throw _iteratorError4;
      }
    }
  }

  for (var _i = 0, _httpRules = httpRules; _i < _httpRules.length; _i++) {
    var _httpRule = _httpRules[_i];
    var _iteratorNormalCompletion5 = true;
    var _didIteratorError5 = false;
    var _iteratorError5 = undefined;

    try {
      for (var _iterator5 = supportedHttpMethods[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
        var httpMethod = _step5.value;

        if (!(httpMethod in _httpRule)) {
          continue;
        }

        var pathTemplate = _httpRule[httpMethod];
        var matchResult = match(snakeRequest, pathTemplate);

        if (typeof matchResult === 'undefined') {
          continue;
        }

        var url = matchResult.url,
            matchedFields = matchResult.matchedFields;

        if (_httpRule.body === '*') {
          // all fields except the matched fields go to request data
          var _data = deepCopy(snakeRequest);

          var _iteratorNormalCompletion6 = true;
          var _didIteratorError6 = false;
          var _iteratorError6 = undefined;

          try {
            for (var _iterator6 = matchedFields[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
              var field = _step6.value;
              deleteField(_data, field);
            } // Remove unset proto3 optional field from the request body.

          } catch (err) {
            _didIteratorError6 = true;
            _iteratorError6 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion6 && _iterator6.return != null) {
                _iterator6.return();
              }
            } finally {
              if (_didIteratorError6) {
                throw _iteratorError6;
              }
            }
          }

          for (var key in _data) {
            if (optionalFields.has(util_1.snakeToCamelCase(key)) && (!(key in snakeRequest) || snakeRequest[key] === 'undefined')) {
              delete _data[key];
            }
          } // HTTP endpoint expects camelCase but we have snake_case at this point


          var _camelCaseData = requestChangeCaseAndCleanup(_data, util_1.snakeToCamelCase);

          return {
            httpMethod: httpMethod,
            url: url,
            queryString: '',
            data: _camelCaseData
          };
        } // one field possibly goes to request data, others go to query string


        var body = _httpRule.body;
        var data = '';
        var queryStringObject = deepCopy(request); // use camel case for query string

        if (body) {
          deleteField(queryStringObject, util_1.snakeToCamelCase(body)); // Unset optional field should not add in body request.

          data = optionalFields.has(body) && snakeRequest[body] === 'undefined' ? '' : snakeRequest[body];
        }

        var _iteratorNormalCompletion7 = true;
        var _didIteratorError7 = false;
        var _iteratorError7 = undefined;

        try {
          for (var _iterator7 = matchedFields[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
            var _field = _step7.value;
            deleteField(queryStringObject, util_1.snakeToCamelCase(_field));
          } // Unset proto3 optional field does not appear in the query params.

        } catch (err) {
          _didIteratorError7 = true;
          _iteratorError7 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion7 && _iterator7.return != null) {
              _iterator7.return();
            }
          } finally {
            if (_didIteratorError7) {
              throw _iteratorError7;
            }
          }
        }

        for (var _key in queryStringObject) {
          if (optionalFields.has(_key) && request[_key] === 'undefined') {
            delete queryStringObject[_key];
          }
        }

        var queryStringComponents = buildQueryStringComponents(queryStringObject);
        var queryString = queryStringComponents.join('&');
        var camelCaseData = void 0;

        if (typeof data === 'string') {
          camelCaseData = data;
        } else {
          camelCaseData = requestChangeCaseAndCleanup(data, util_1.snakeToCamelCase);
        }

        return {
          httpMethod: httpMethod,
          url: url,
          queryString: queryString,
          data: camelCaseData
        };
      }
    } catch (err) {
      _didIteratorError5 = true;
      _iteratorError5 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion5 && _iterator5.return != null) {
          _iterator5.return();
        }
      } finally {
        if (_didIteratorError5) {
          throw _iteratorError5;
        }
      }
    }
  }

  return undefined;
}

exports.transcode = transcode;